import { GraphQLClientProvider } from '@dixa/lib-integrations-partner-widgets';
import { config } from 'lib-shared-backend-config';
import { PropsWithChildren } from 'lib-shared-types-utils';
import { FormProvider as OAuthFormProvider, useForm } from 'react-hook-form';

import { OAuthFormData } from './oAuth.types';

/** Represents the provider for OAuth. */
export const OAuthProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const oAuthForm = useForm<OAuthFormData>({
    defaultValues: {
      id: '',
      name: '',
    },
    mode: 'onTouched',
  });

  return (
    <GraphQLClientProvider
      configuration={{ baseUrl: config.url.partnerIntegrations }}
    >
      <OAuthFormProvider {...oAuthForm}>{children}</OAuthFormProvider>
    </GraphQLClientProvider>
  );
};
